import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useLocation, Link } from 'react-router-dom'
import styled from 'styled-components'
import BigNumber from 'bignumber.js/bignumber'
import { useWeb3React } from '@web3-react/core/core/core'
import { Heading, Flex, Skeleton, Text, CopyIcon, Box, FlexProps, IconButton, Button, BaseLayout, useModal , Image, ButtonMenu,ButtonMenuItem} from '@pancakeswap/uikit'
import orderBy from 'lodash/orderBy'
import partition from 'lodash/partition'
import { useTranslation } from 'contexts/Localization'
import usePersistState from 'hooks/usePersistState'
import { useFetchPublicPoolsData, usePools, useFetchCakeVault, useCakeVault  } from 'state/pools/hooks'
import { usePool4 , usePool5, usePool6 , usePool7, usePool8 , usePool9, usePool10, usePool11, usePool12, usePool13, usePool14, usePool15, usePool16, usePool17, usePool18 , usePool19, usePool20, usePool21 , usePool22, usePool23, usePool24, usePool25, usePool26, usePool27, usePool29, usePool28, usePool30, usePool31, usePool32, usePool33, usePool34, usePool35, usePool36, usePool37, usePool38, usePool39, usePool40, usePool41, usePool42,usePool43, usePool44, usePool45, usePool47, usePool46, useGetBnbBalance, useDonate} from 'hooks/useTokenBalance'
import { usePollFarmsData , usePriceBnbBusd, usePriceCakeBusd , usePriceHVIBusd, usePriceLameaBusd , usePriceETCBusd , usePriceBABYVIZSLABusd , usePriceBVCBusd ,usePriceEXZOBusd , usePriceETHBusd, usePriceATALIRABusd, usePriceLTCBusd,usePriceliraBusd, usePriceLGCBusd, usePricebabyBusd } from 'state/farms/hooks'
import { getAddress, getHVIAddress , getCakeAddress, getWbnbAddress,geLiraAddress, getethAddress, getLAMEAAddress, getbvcAddress, getbabyvizslaAddress , getltcAddress, getetcAddress, getataliraAddress, getexzoAddress, getlgcAddress, getbabyAddress, getBusdAddress} from 'utils/addressHelpers'
import { getBalanceNumber, formatLocalisedCompactNumber, getFullDisplayBalance, getDecimalAmount, getDecimalAmount100 } from 'utils/formatBalance'
import { latinise } from 'utils/latinise'
import FlexLayout from 'components/Layout/Flex'
import Page from 'components/Layout/Page'
import PageHeader from 'components/PageHeader'
import SearchInput from 'components/SearchInput'
import Select, { OptionProps } from 'components/Select/Select'
import { Pool } from 'state/types'
import { BIG_ZERO, ethersToBigNumber } from 'utils/bigNumber'
import Loading from 'components/Loading'
import { useTokenBalance } from 'state/wallet/hooks'
import Balance from 'components/Balance'
import { useGetStats } from 'hooks/api'
import PoolCard from './components/PoolCard'
import CakeVaultCard from './components/CakeVaultCard'
import PoolTabButtons from './components/PoolTabButtons'
import BountyCard from './components/BountyCard'
import HelpButton from './components/HelpButton'
import ModalInfo from './components/ModalInfo'
import ModalInfo1 from './components/ModalInfo1'
import ModalInfo3 from './components/ModalInfo3'
import PoolsTable from './components/PoolsTable/PoolsTable'
import { ViewMode } from './components/ToggleView/ToggleView'
import { getAprData, getCakeVaultEarnings } from './helpers'
import ModalInfo4 from './components/ModalInfo4'
import ModalInfo5 from './components/ModalInfo5'
import YoutubeEmbed from './components/YoutubeEmbed'

interface CopyAddressProps extends FlexProps {
  account: string
}
const Wrapper = styled(Flex)`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 8px;
  position: relative;
  margin-bottom: 40px;
`
const Address = styled.div`

background-color: rgb(19,47,46) ;
border-radius: 8px;
`
const Cards = styled(BaseLayout)`
align-items: stretch;
justify-content: stretch;
grid-gap: 24px;
margin-bottom: 10px;



& > div {
  grid-column: span 6;
  width: 100%;
  border-radius: 8px;
}

${({ theme }) => theme.mediaQueries.sm} {
  margin-bottom: 10px;

  & > div {
    grid-column: span 8;
      border-radius: 8px;

  }
}

${({ theme }) => theme.mediaQueries.lg} {
  grid-gap: 32px;
  margin-bottom: 20px;

  & > div {
    grid-column: span 6;
    border-radius: 8px;

  }
}

${({ theme }) => theme.mediaQueries.md} {
  margin-bottom: 20px;
  grid-gap: 32px;
  & > div {
    grid-column: span 6;
    border-radius: 8px;

  }
}
`

const Tooltip = styled.div<{ isTooltipDisplayed: boolean }>`
  display: ${({ isTooltipDisplayed }) => (isTooltipDisplayed ? 'inline-block' : 'none')};
  position: absolute;
  padding: 8px;
  top: -38px;
  right: 0;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.contrast};
  color: ${({ theme }) => theme.colors.invertedContrast};
  border-radius: 8px;
  opacity: 0.7;
  width: 100px;
`
const CardLayout = styled(FlexLayout)`
  justify-content: center;
`
const Divider = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundDisabled};
  height: 1px;
  margin-top: 16px ;
  margin-bottom: 16px ;
  width: 100%;
`
const DetailsWrapper = styled.div`
  order: 1;
  margin-bottom: 40px;

  ${({ theme }) => theme.mediaQueries.md} {
    order: 2;
    margin-bottom: 0;
    margin-left: 40px;
  }
`
const StyledModalContainer2 = styled(Text)`
font-size: 10px;

  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 15px;

  }
`
const StyledModalContainer = styled(Box)`
  max-width: 1200px;
  width: 100%;
  background-color: rgba(0,0,0);
  border-radius: 25px;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  border: 1px solid ${({ theme }) => theme.colors.text};
  ${({ theme }) => theme.mediaQueries.md} {
    max-width: 1200px;
    align-items: center;
    width: 100%;
    justify-content: center;
    margin-bottom: 20px;
    border: 1px solid ${({ theme }) => theme.colors.text};
    background-color: rgba(0,0,0);
    border-radius: 25px;
  }
`
const ExpandedWrapper = styled(Flex)`
  svg {
    height: 14px;
    width: 14px;
  }
`

const PoolControls = styled(Flex)`
display: flex;
width: 100%;
align-items: center;
position: relative;

justify-content: space-between;
flex-direction: column;
margin-bottom: 35px;
border-radius: 16px;

${({ theme }) => theme.mediaQueries.sm} {
  flex-direction: row;
    flex-wrap: wrap;
    border: solid 1.5px ${({ theme }) => theme.colors.cardBorder};
    padding: 20px 32px;
    margin-bottom: 50;
}
`
const Lol = styled(Box)`
margin-right: 25px;
margin-left: 25px;
align-items: center;
justify-content: center;
${({ theme }) => theme.mediaQueries.md} {
  margin-right: 55px;
  margin-left: 55px;
  align-items: center;
  justify-content: center;
} 
`
const ScrollBox = styled(Box)`
background-color: rgba(0,0,0);
padding: 10px;
width: 210px;
margin-top: 20px;
margin-bottom: -10px;
border: 0.05px solid ${({ theme }) => theme.colors.secondary};
border-radius: 10px;
${({ theme }) => theme.mediaQueries.md} {
  background-color: rgba(0,0,0);
  width: 210px;
  margin-bottom: -20px;
  padding: 10px;
  border: 0.05px solid ${({ theme }) => theme.colors.text};
  border-radius: 10px;
}
`
const ImageWrapper = styled.div`

${({ theme }) => theme.mediaQueries.md} {


}
`

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 0px;

  ${({ theme }) => theme.mediaQueries.sm} {
    width: auto;
    padding: 0;
  }
`

const LabelWrapper = styled.div`
  > ${Text} {
    font-size: 12px;
  }
`

const ControlStretch = styled(Flex)`
  > div {
    flex: 1;
  }
`

const NUMBER_OF_POOLS_VISIBLE = 12

const Donation: React.FC = () => {
  const location = useLocation()
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const { pools: poolsWithoutAutoVault, userDataLoaded } = usePools(account)
  const [stakedOnly, setStakedOnly] = usePersistState(false, { localStorageKey: 'pancake_pool_staked' })
  const [numberOfPoolsVisible, setNumberOfPoolsVisible] = useState(NUMBER_OF_POOLS_VISIBLE)
  const [observerIsSet, setObserverIsSet] = useState(false)
  const loadMoreRef = useRef<HTMLDivElement>(null)
  const [viewMode, setViewMode] = usePersistState(ViewMode.TABLE, { localStorageKey: 'pancake_pool_view' })
  const [searchQuery, setSearchQuery] = useState('')
  const [sortOption, setSortOption] = useState('hot')
  const chosenPoolsLength = useRef(0)
  const {
    userData: { cakeAtLastUserAction, userShares },
    fees: { performanceFee },
    pricePerFullShare,
    totalCakeInVault,
  } = useCakeVault()
  const accountHasVaultShares = userShares && userShares.gt(0)
  const [isTooltipDisplayed, setIsTooltipDisplayed] = useState(false)
  const copyAddress = () => {
    if (navigator.clipboard && navigator.permissions) {
      navigator.clipboard.writeText('0xbf3B713827d5DA58E25711e746922b0A6233DE86').then(() => displayTooltip())
    } else if (document.queryCommandSupported('copy')) {
      const ele = document.createElement('textarea')
      ele.value = account
      document.body.appendChild(ele)
      ele.select()
      document.execCommand('copy')
      document.body.removeChild(ele)
      displayTooltip()
    }
  }
  function displayTooltip() {
    setIsTooltipDisplayed(true)
    setTimeout(() => {
      setIsTooltipDisplayed(false)
    }, 1000)
  }
  const [isExpanded, setIsExpanded] = useState(false)
  const [isExpanded2, setIsExpanded2] = useState(false)

  const performanceFeeAsDecimal = performanceFee && performanceFee / 100

  const pools = useMemo(() => {
    const cakePool = poolsWithoutAutoVault.find((pool) => pool.sousId === 0)
    const cakeAutoVault = { ...cakePool, isAutoVault: false }
    return [cakeAutoVault, ...poolsWithoutAutoVault]
  }, [poolsWithoutAutoVault])

  const vizslapools = pools.filter((pool) => pool.sousId !== -1 && pool.tokensymbol3  === 'VIZSLASWAP')
  const hvipools = pools.filter((pool) => pool.sousId !== -1 && pool.tokensymbol3  === 'HVI')
  const antiwhalepools = pools.filter((pool) => pool.sousId !== -1 && pool.tokensymbol4  === 'ANTIWHALE')
  const all = pools.filter((pool) => pool.sousId !== -1 && pool.tokensymbol5  === 'ALL100000')

  const VIZSLAPRICE0 = usePriceCakeBusd()
  const vizslaprice = VIZSLAPRICE0.toNumber()
  const HVIPRICE0 = usePriceHVIBusd()
  const HVIPRICE = HVIPRICE0.toNumber()
  const VIZSLAPRICE = VIZSLAPRICE0.toNumber()
  const WBNBPRICE0 = usePriceBnbBusd()
  const WBNBPRICE = WBNBPRICE0.toNumber()
  const ETHPPRICE0 = usePriceETHBusd()
  const ETHPRICE = ETHPPRICE0.toNumber()
  const ETCPRICE0 = usePriceETCBusd()
  const ETCPRICE = ETCPRICE0.toNumber()
  const LTCPRICE0 = usePriceLTCBusd()
  const LTCPRICE = LTCPRICE0.toNumber()
  const LAMEAPRICE0 = usePriceLameaBusd()
  const LAMEAPRICE = LAMEAPRICE0.toNumber()
  const ATALIRAPRICE0 = usePriceATALIRABusd()
  const ATALIRAPRICE = ATALIRAPRICE0.toNumber()
  const EXZOPRICE0 = usePriceEXZOBusd()
  const EXZOPRICE = EXZOPRICE0.toNumber()
  const BVCPRICE0 = usePriceBVCBusd()
  const BVCPRICE = BVCPRICE0.toNumber()
  const BABYVIZSLAPRICE0 = usePriceBABYVIZSLABusd()
  const BABYVIZSLAPRICE = BABYVIZSLAPRICE0.toNumber()
  const liraprice0 = usePriceliraBusd()
  const babyprice0 = usePricebabyBusd()
  const babyprice = babyprice0.toNumber()
const liraprice = liraprice0.toNumber()
const lgcprice0 = usePriceLGCBusd()
const lgcprice = lgcprice0.toNumber()

const vizsladonate = getBalanceNumber(useDonate(getCakeAddress()))
const vizsla = vizsladonate * vizslaprice
const vizsladonate2 = getBalanceNumber(useDonate(getBusdAddress()))
const vizsla2 = vizsladonate2 * 1 

const data = useGetStats()
  const tvl = data ? data.result.toLocaleString('en-US', { maximumFractionDigits: 0 }) : null
 const tvl2 =  getDecimalAmount100(new BigNumber(tvl))
 const tvl3 = tvl2.times(WBNBPRICE).plus(vizsla).plus(vizsla2).toFixed(2)

  // TODO aren't arrays in dep array checked just by reference, i.e. it will rerender every time reference changes?
  const [finishedPools, openPools] = useMemo(() => partition(pools, (pool) => pool.isFinished), [pools])
  usePollFarmsData()
  useFetchCakeVault()
  useFetchPublicPoolsData()

  const showFinishedPools = location.pathname.includes('history')
  const showvizslapools = location.pathname.includes('vizslapools')
  const showhvipools = location.pathname.includes('hvipools')
  const showantiwhalepools = location.pathname.includes('antiwhalepools')
  const showall = location.pathname.includes('open')
  const getActiveIndex = (pathname: string): number => {
    if (
      pathname.includes('/pools/all') ||
      pathname.includes('/pools/finished')
    ) {
      return 0
    }
    return 1
  }
  const handleChangeSearchQuery = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value)
  }

  const handleSortOptionChange = (option: OptionProps): void => {
    setSortOption(option.value)
  }

  const sortPools = (poolsToSort: Pool[]) => {
    switch (sortOption) {
      case 'apr':
        // Ternary is needed to prevent pools without APR (like MIX) getting top spot
        return orderBy(
          poolsToSort,
          (pool: Pool) => (pool.apr ? getAprData(pool, performanceFeeAsDecimal).apr : 0),
          'desc',
        )
      case 'earned':
        return orderBy(
          poolsToSort,
          (pool: Pool) => {
            if (!pool.userData || !pool.earningTokenPrice) {
              return 0
            }
            return pool.isAutoVault
              ? getCakeVaultEarnings(
                  account,
                  cakeAtLastUserAction,
                  userShares,
                  pricePerFullShare,
                  pool.earningTokenPrice,
                ).autoUsdToDisplay
              : pool.userData.pendingReward.times(pool.earningTokenPrice).toNumber()
          },
          'desc',
        )
      case 'totalStaked':
        return orderBy(
          poolsToSort,
          (pool: Pool) => (pool.isAutoVault ? totalCakeInVault.toNumber() : pool.totalStaked.toNumber()),
          'desc',
        )
      default:
        return poolsToSort
    }
  }

  let chosenPools
  if (showFinishedPools) {
    chosenPools = finishedPools
  } else {
    chosenPools =  openPools
  }
  if (showall) {
    chosenPools =  all
  } 



  if (searchQuery) {
    const lowercaseQuery = latinise(searchQuery.toLowerCase())
    chosenPools = chosenPools.filter((pool) =>
      latinise(pool.earningToken.symbol.toLowerCase()).includes(lowercaseQuery),
    )
  }

  chosenPools = sortPools(chosenPools).slice(0, numberOfPoolsVisible)
  chosenPoolsLength.current = chosenPools.length
  const TooltipComponent = ({ fee }: { fee: number }) => (
    <>
      <Text mb="16px">{t('This bounty is given as a reward for providing a service to other users.')}</Text>
      <Text mb="16px">
        {t(
          'Whenever you successfully claim the bounty, you’re also helping out by activating the Auto VIZSLASWAP Pool’s compounding function for everyone.',
        )}
      </Text>
      <Text style={{ fontWeight: 'bold' }}>
        {t('Auto-Compound Bounty: %fee%% of all Auto VIZSLASWAP pool users pending yield', { fee: fee / 100 })}
      </Text>
    </>
  )
  const [onPresentBountyModal] = useModal(<ModalInfo TooltipComponent={TooltipComponent} />)
  const [onPresentBountyModal2] = useModal(<ModalInfo1 TooltipComponent={TooltipComponent} />)
  const [onPresentBountyModal3] = useModal(<ModalInfo3 TooltipComponent={TooltipComponent} />)
  const [onPresentBountyModal4] = useModal(<ModalInfo4 TooltipComponent={TooltipComponent} />)
  const [onPresentBountyModal5] = useModal(<ModalInfo5 TooltipComponent={TooltipComponent} />)

  const cardLayout = (
    <CardLayout>
      {chosenPools.map((pool) =>
        pool.isAutoVault ? (
          <CakeVaultCard key="auto-cake" pool={pool} showStakedOnly={stakedOnly} />
        ) : (
          <PoolCard key={pool.sousId} pool={pool} account={account} />
        ),
      )}
    </CardLayout>
  )

  const tableLayout = <PoolsTable pools={chosenPools} account={account} userDataLoaded={userDataLoaded} />

  return (
    <>
      <PageHeader>
        <Flex justifyContent="space-between" flexDirection={['column', null, null, 'row']}>
          <Flex flex="1" flexDirection="column" mr={['8px', 0]}>
            <Heading as="h1" scale="xxl" color="secondary" mb="24px">
              {t('Charity')}
            </Heading>
            <Heading scale="md" color="text">
              {t('Help us support animal shelters in Hungary.')}
            </Heading>
          </Flex>
        </Flex>
      </PageHeader>
    
      <Page>
      <StyledModalContainer>

<Flex flex="1" flexDirection="column" justifyContent="center" alignItems="center" mr={['8px', 0]}>
      <Lol>
      <Flex flex="1" flexDirection="column" justifyContent="center" alignItems="center" >
      <Heading  scale="xl" color="secondary" mt="20px" mb="10px">
        {t('How can you help?')}
      </Heading>
      </Flex>
      <Flex flex="1" flexDirection="column" justifyContent="center" alignItems="center" >
      <Flex  justifyContent="center" alignItems="center" >
      <Text  color="text" fontSize='15px' mb="10px" >
        {t('Send any amount you are comfortable with to the following address:')}
      </Text>
      </Flex>
      <Flex justifyContent="center" alignItems="center"  mr={['8px', 0]} mb="10px" >
      <ImageWrapper>
  <img src="/images/wallet/1.png" alt="1" width="35px" height="35px"/>
</ImageWrapper>
<ImageWrapper>
  <img src="/images/wallet/black.png" alt="1" width="4px" height="4px"/>
</ImageWrapper>
<ImageWrapper>
  <img src="/images/wallet/4.png" alt="4" width="35px" height="35px"/>
</ImageWrapper>
<ImageWrapper>
<img src="/images/wallet/black.png" alt="1" width="4px" height="4px"/>
</ImageWrapper>
<ImageWrapper>
  <img src="/images/wallet/2.png" alt="2" width="35px" height="35px"/>
</ImageWrapper>
</Flex>

<Flex justifyContent="center" alignItems="center"  >

  <Text  color="primary" fontSize='12px' mb="3px" textAlign="center" >
        {t('Copy BEP-20 address:')}
      </Text>
      <IconButton variant="text" onClick={copyAddress}>
    <CopyIcon color="primary" width="24px" />
  </IconButton>
  </Flex>

      <StyledModalContainer2 color="text"> {t('0xbf3B713827d5DA58E25711e746922b0A6233DE86')}</StyledModalContainer2>

<Tooltip isTooltipDisplayed={isTooltipDisplayed}>{t('Copied')}</Tooltip>
      </Flex> 
      <Divider />
      <Flex  justifyContent="center" alignItems="center" >
      <Image src="/images/pixel/0909.png"  width={290} height={168}  />
      </Flex>  
      <Flex flex="1" flexDirection="column" justifyContent="center" alignItems="center" >
      <Heading  scale="xl" color="secondary" mt="20px" mb="10px">
        {t('Charity images')}
      </Heading>
      </Flex>
      <Flex flex="1" flexDirection="column" justifyContent="center" alignItems="center" >
      <Text  color="text" fontSize='15px' mb="10px" >
        {t('Pictures that you can share')}
      </Text>
      </Flex>
      <Flex flex="1" justifyContent="center" alignItems="center" mb="10px">
            <Button
              onClick={onPresentBountyModal5}
              scale="sm"
              variant='secondary'
              id="clickClaimVaultBounty"
              mr="10px"
            >
               <Text  color="text" fontSize='15px' >
        {t('Charity 5')}
      </Text>
 
            </Button>
            <Button
              onClick={onPresentBountyModal4}
              scale="sm"
              variant='secondary'
              id="clickClaimVaultBounty"
              mr="10px"
            >
               <Text  color="text" fontSize='15px' >
        {t('Charity 4')}
      </Text>
 
            </Button>
            <Button
              onClick={onPresentBountyModal3}
              scale="sm"
              variant='secondary'
              id="clickClaimVaultBounty"
            >
               <Text  color="text" fontSize='15px' >
        {t('Charity 3')}
      </Text>
 
            </Button>
            </Flex>
            <Flex flex="1" justifyContent="center" alignItems="center" mb="30px" >
            <Button
              onClick={onPresentBountyModal}
              scale="sm"
              variant='secondary'
              id="clickClaimVaultBounty"
              mr="10px"
            >
               <Text  color="text" fontSize='15px' >
        {t('Charity 2')}
      </Text>
 
            </Button>
            <Button
              onClick={onPresentBountyModal2}
              scale="sm"
              variant='secondary'
              id="clickClaimVaultBounty"
            >
               <Text  color="text" fontSize='15px' >
        {t('Charity 1')}
      </Text>
 
            </Button>
            </Flex>
            <Cards> 
            <YoutubeEmbed embedId="s9pzxEkZAg0"  />

            <Flex flex="1" justifyContent="center" alignItems="center" mb="10px">
            <Text  color="isten" fontSize='14px' mb="30px" >
        {t('…to support a good cause. And that is helping dogs in need. That’s why we primarily support dog shelters. And you can also take part of it, because with every HVI transaction* you contribute to this honorable goal.')}
      </Text>
      </Flex>
      </Cards> 
      </Lol>

</Flex>

 

  </StyledModalContainer>

        </Page>
    </>
  )
}

export default Donation
